import React, { useState, useMemo } from 'react';
import CalcShell, { StepsPanel } from '../CalcShell';
import { CalcNetPanel, Row, UnitInput, FeetInches, RadioGroup, ResultTable } from '../_fitnessHelpers';

export default function AnorexicBMICalc() {
  const [tab, setTab] = useState(0);
  const [age, setAge] = useState(25);
  const [gender, setGender] = useState('female');
  const [ft, setFt] = useState(5);
  const [inches, setInches] = useState(5);
  const [lb, setLb] = useState(100);
  const [cm, setCm] = useState(165);
  const [kg, setKg] = useState(45);
  const clear = () => { setAge(25); setGender('female'); setFt(5); setInches(5); setLb(100); setCm(165); setKg(45); };

  const c = useMemo(() => {
    const h = tab === 0 ? ((+ft||0)*12 + (+inches||0))*0.0254 : (+cm||0)/100;
    const w = tab === 0 ? (+lb||0)*0.453592 : +kg||0;
    const bmi = h > 0 ? w/(h*h) : 0;
    const anorexic = bmi < 17.5;
    const idealMin = 18.5*h*h, idealMax = 24.9*h*h;
    const disp = k => tab === 0 ? `${(k/0.453592).toFixed(1)} lb` : `${k.toFixed(1)} kg`;
    return { bmi, anorexic, idealMin, idealMax, disp };
  }, [tab, ft, inches, lb, cm, kg]);

  return (
    <CalcShell look="cnet" title="Anorexic BMI Calculator" subtitle="Flag a BMI below the clinical anorexia threshold (BMI < 17.5).">
      <CalcNetPanel slug="ano" activeTab={tab} onTabChange={setTab} onClear={clear} right={
        <div>
          <div className="text-lg text-slate-800">BMI</div>
          <div className="text-2xl font-bold" style={{ color: c.anorexic ? '#dc2626' : '#2f9c3f' }} data-testid="ano-bmi">{c.bmi.toFixed(2)}</div>
          <div className={`p-3 rounded text-sm mt-3 ${c.anorexic?'bg-red-50 text-red-800':'bg-green-50 text-green-800'}`}>
            {c.anorexic ? 'Your BMI is in the anorexic range (BMI < 17.5). Please consult a healthcare professional.' : 'Your BMI is above the anorexic threshold.'}
          </div>
          <ResultTable testid="ano-info-table" rows={[
            ['Healthy weight range', `${c.disp(c.idealMin)} – ${c.disp(c.idealMax)}`],
            ['Anorexic threshold BMI', '17.5'],
          ]}/>
        </div>
      }>
        <Row label="Age"><UnitInput value={age} onChange={setAge} testid="ano-age" /></Row>
        <Row label="Gender"><RadioGroup name="ano-g" value={gender} onChange={setGender} options={[{value:'male',label:'male'},{value:'female',label:'female'}]}/></Row>
        {tab === 0 ? <>
          <Row label="Height"><div className="grid grid-cols-2 gap-2 flex-1"><FeetInches ft={ft} inches={inches} onFt={setFt} onIn={setInches} testidPrefix="ano-h"/></div></Row>
          <Row label="Weight"><UnitInput value={lb} onChange={setLb} unit="pounds" testid="ano-w"/></Row>
        </> : <>
          <Row label="Height"><UnitInput value={cm} onChange={setCm} unit="cm" testid="ano-hcm"/></Row>
          <Row label="Weight"><UnitInput value={kg} onChange={setKg} unit="kg" testid="ano-wkg"/></Row>
        </>}
      </CalcNetPanel>
    </CalcShell>
  );
}
